/** WorkOS built-in org roles — descriptions ship in English from WorkOS. */
const WORKOS_SYSTEM_ROLE_DESCRIPTIONS_PT: Record<string, string> = {
  member: 'Papel padrão do WorkOS para membros da organização.',
  admin: 'Acesso para gerenciar os recursos disponíveis na organização (papel de sistema WorkOS).',
  viewer: 'Acesso somente leitura a todos os módulos.',
};

export const identityRolesPtBr = {
  description: {
    ...WORKOS_SYSTEM_ROLE_DESCRIPTIONS_PT,
  },
  type: {
    system: 'Sistema',
    custom: 'Personalizado',
  },
  actions: {
    edit: 'Editar',
    delete: 'Excluir',
    deleteDisabled:
      'Papéis de sistema são gerenciados pelo WorkOS e não podem ser excluídos. Apenas papéis personalizados (org-*) podem ser removidos.',
  },
  select: {
    placeholder: 'Selecione papéis',
    search: 'Buscar papel...',
    empty: 'Nenhum papel encontrado',
    remove: 'Remover {{name}}',
    selectedCount_one: '{{count}} papel selecionado',
    selectedCount_other: '{{count}} papéis selecionados',
  },
};

export const identityRolesEn = {
  description: {
    member: 'Default WorkOS role for organization members.',
    admin: 'Access to manage all available resources (WorkOS system role).',
    viewer: 'Read-only access to all modules.',
  },
  type: {
    system: 'System',
    custom: 'Custom',
  },
  actions: {
    edit: 'Edit',
    delete: 'Delete',
    deleteDisabled:
      'System roles are managed by WorkOS and cannot be deleted. Only custom roles (org-*) can be removed.',
  },
  select: {
    placeholder: 'Select roles',
    search: 'Search role...',
    empty: 'No roles found',
    remove: 'Remove {{name}}',
    selectedCount_one: '{{count}} role selected',
    selectedCount_other: '{{count}} roles selected',
  },
};
